import { useId } from 'react'
import type { ReactElement } from 'react'
import { DesktopPromptFrame } from './DesktopPromptFrame'
import { PROMPT_COPY } from './promptCopy'
import heroLight from './assets/desktop2-hero-light.png'
import heroDark from './assets/desktop2-hero-dark.png'
import qrDesktop2 from './assets/qr-desktop-2.svg'
import styles from './DesktopPhonePrompt.module.css'

/**
 * Desktop, variant 2 — the app on a phone + QR (Figma 9371:89081 /
 * 9375:18774). The hero is the Figma "App preview / clipped phone" layer
 * exported whole (9371:88961 / 9375:18794), one per theme.
 */
export function DesktopPhonePrompt({ onClose }: { readonly onClose: () => void }): ReactElement {
  const titleId = useId()
  return (
    <DesktopPromptFrame labelledBy={titleId} variant="v2" onClose={onClose}>
      <div className={styles.hero}>
        <img className={styles.heroLight} src={heroLight} alt="" width={640} height={330} />
        <img className={styles.heroDark} src={heroDark} alt="" width={640} height={330} />
      </div>
      <div className={styles.body}>
        <h2 id={titleId} className={styles.title}>
          {PROMPT_COPY.desktop2.title}
        </h2>
        <p className={styles.subtitle}>{PROMPT_COPY.desktop2.subtitle}</p>
        <div className={styles.qrBox}>
          <img className={styles.qr} src={qrDesktop2} alt="" width={116} height={116} />
          <div className={styles.qrText}>
            <p className={styles.qrTitle}>{PROMPT_COPY.desktop2.qrTitle}</p>
            <p className={styles.qrDetail}>{PROMPT_COPY.desktop2.qrDetail}</p>
          </div>
        </div>
      </div>
    </DesktopPromptFrame>
  )
}
